import { 
  LayoutDashboard, 
  CreditCard, 
  QrCode, 
  BarChart3, 
  Settings 
} from 'lucide-react'
import { NavLink } from 'react-router-dom'
import './Dashboard.css'

export default function MobileBottomNav() {
  const navItems = [
    { path: '/dashboard', icon: <LayoutDashboard size={24} />, label: 'Overview', end: true },
    { path: '/dashboard/edit', icon: <CreditCard size={24} />, label: 'Edit' },
    { path: '/dashboard/qr', icon: <QrCode size={24} />, label: 'QR' },
    { path: '/dashboard/analytics', icon: <BarChart3 size={24} />, label: 'Stats' },
    { path: '/dashboard/settings', icon: <Settings size={24} />, label: 'Settings' }
  ]

  return (
    <div className="mobile-bottom-nav hide-desktop">
      {navItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          end={item.end}
          className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}
        >
          {item.icon}
          <span className="bottom-nav-label">{item.label}</span>
        </NavLink>
      ))}
    </div>
  )
}
